import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, ArrowUpRight } from "lucide-react";
import { NAV, SITE } from "@/lib/site";

export default function Footer() {
  return (
    <footer className="bg-[hsl(var(--gaza-navy-deep))] text-white/80 border-t border-white/10" data-testid="site-footer">
      <div className="container-gaza py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="inline-block bg-white p-4 mb-6">
            <img
              src={`${process.env.PUBLIC_URL || ""}/brand/backhome_lockup.png`}
              alt="BackHome Restoration Inc."
              className="h-16 w-auto"
              data-testid="footer-logo"
            />
          </div>
          <p className="text-white/75 max-w-md leading-relaxed">
            BackHome Restoration Inc. delivers 24/7 emergency restoration, contents assessment, pack-out and pack-back, storage and professional moving services across Toronto and the GTA.
          </p>
          <a href={SITE.phoneHref} className="mt-8 inline-flex items-center gap-3 group" data-testid="footer-phone-cta">
            <span className="w-11 h-11 grid place-items-center bg-[hsl(var(--gaza-crimson-bright))] group-hover:bg-white transition"><Phone className="w-4 h-4 text-white group-hover:text-[hsl(var(--gaza-crimson-bright))]" /></span>
            <span>
              <div className="text-[10px] tracking-[0.28em] uppercase text-white/65 font-extrabold">24/7 Emergency Line</div>
              <div className="display-chunky text-2xl text-white group-hover:text-[hsl(var(--gaza-crimson-bright))] transition">{SITE.phone}</div>
            </span>
          </a>
          <a href={SITE.emailHref} className="mt-4 inline-flex items-center gap-3 text-white/75 hover:text-white transition" data-testid="footer-email-cta">
            <Mail className="w-4 h-4 text-[hsl(var(--gaza-crimson-bright))]" />
            <span className="break-all">{SITE.email}</span>
          </a>
        </div>

        <div className="md:col-span-3">
          <div className="text-[11px] tracking-[0.28em] uppercase text-[hsl(var(--gaza-crimson-bright))] font-extrabold mb-5">Navigate</div>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-white/80 hover:text-white inline-flex items-center gap-2 group font-medium" data-testid={`footer-nav-${n.label.toLowerCase()}`}>
                  <ArrowUpRight className="w-3.5 h-3.5 text-[hsl(var(--gaza-crimson-bright))] opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition" />
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-[11px] tracking-[0.28em] uppercase text-[hsl(var(--gaza-crimson-bright))] font-extrabold mb-5">Reach Us</div>
          <ul className="space-y-4 text-sm">
            <li className="flex gap-3"><Clock className="w-4 h-4 text-[hsl(var(--gaza-crimson-bright))] mt-0.5" /> <span><span className="text-white font-semibold">24/7 Emergency Response</span><br/><span className="text-white/65">Available every day of the year</span></span></li>
            <li className="flex gap-3"><MapPin className="w-4 h-4 text-[hsl(var(--gaza-crimson-bright))] mt-0.5" /> <span className="text-white/85">Serving Toronto & the Greater Toronto Area</span></li>
            <li className="flex gap-3"><Phone className="w-4 h-4 text-[hsl(var(--gaza-crimson-bright))] mt-0.5" /> <a href={SITE.phoneHref} className="text-white/85 hover:text-white" data-testid="footer-phone">{SITE.phone}</a></li>
            <li className="flex gap-3"><Mail className="w-4 h-4 text-[hsl(var(--gaza-crimson-bright))] mt-0.5" /> <a href={SITE.emailHref} className="text-white/85 hover:text-white break-all" data-testid="footer-email">{SITE.email}</a></li>
            <li className="flex gap-3"><Mail className="w-4 h-4 text-[hsl(var(--gaza-crimson-bright))] mt-0.5" /> <a href={SITE.hrEmailHref} className="text-white/85 hover:text-white break-all" data-testid="footer-hr-email">{SITE.hrEmail} <span className="text-white/50">· Careers</span></a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-gaza py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/55">
          <div>© {new Date().getFullYear()} BackHome Restoration Inc. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/legal" className="hover:text-white" data-testid="footer-legal">Legal Notice</Link>
            <Link to="/contact" className="hover:text-white" data-testid="footer-contact">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
